import LinkIcon from "@mui/icons-material/Link";
import { IconButton, Snackbar, Tooltip } from "@mui/material";
import { useVideoControlState } from "components/scrapEyeDataDashboard/VideoPlayer/contexts/VideoControlContext";
import { Dayjs } from "dayjs";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import { useState } from "react";

interface CopyLinkTarget {
  tool: string;
  timeParam: string;
}

const VIEWER_LINK_TARGET: CopyLinkTarget = { tool: "viewer", timeParam: "t" };

export const MANUAL_REVIEW_LINK_TARGET: CopyLinkTarget = {
  tool: "manual-review",
  timeParam: "date",
};

export const CopyLinkButton = ({
  location,
  videoStart,
  linkTarget = VIEWER_LINK_TARGET,
  iconFontSize,
}: {
  location: string;
  videoStart: Dayjs;
  linkTarget?: CopyLinkTarget;
  iconFontSize?: "small" | "medium";
}) => {
  const { t } = useTenantTranslation();
  const tenantName = useTenant();
  const { currentTime } = useVideoControlState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleClick = () => {
    const absoluteTimestamp = videoStart
      .add(currentTime, "second")
      .toISOString();
    const url = `${window.location.origin}/${tenantName}/tool/${linkTarget.tool}/${location}?${linkTarget.timeParam}=${absoluteTimestamp}`;
    void navigator.clipboard.writeText(url);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Tooltip title={t("copyLink")}>
        <IconButton onClick={handleClick} size="small">
          <LinkIcon fontSize={iconFontSize} />
        </IconButton>
      </Tooltip>
      <Snackbar
        open={snackbarOpen}
        onClose={() => {
          setSnackbarOpen(false);
        }}
        autoHideDuration={2000}
        message={t("linkCopied")}
      />
    </>
  );
};
